var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crumbs"},[_c('div',{staticClass:"content"},[_c('h4',[_vm._v(_vm._s(_vm.title))])]),_vm._t("close")],2)}
var staticRenderFns = []

export { render, staticRenderFns }